import * as api from '../../api/appraisalDemo/search';
import { makeApiActionCreatorV3 } from '../utils';

export const SEARCH_OPTIONS_FETCH_START = 'SEARCH/SEARCH_OPTIONS_FETCH_START';
export const SEARCH_OPTIONS_FETCH_SUCCESS =
  'SEARCH/SEARCH_OPTIONS_FETCH_SUCCESS';
export const SEARCH_OPTIONS_FETCH_ERROR = 'SEARCH/SEARCH_OPTIONS_FETCH_ERROR';

export const PROPERTY_SEARCH_START = 'SEARCH/PROPERTY_SEARCH_START';
export const PROPERTY_SEARCH_SUCCESS = 'SEARCH/PROPERTY_SEARCH_SUCCESS';
export const PROPERTY_SEARCH_ERROR = 'SEARCH/PROPERTY_SEARCH_ERROR';

export const PROPERTY_FIELDS_FETCH_START = 'SEARCH/PROPERTY_FIELDS_FETCH_START';
export const PROPERTY_FIELDS_FETCH_SUCCESS =
  'SEARCH/PROPERTY_FIELDS_FETCH_SUCCESS';
export const PROPERTY_FIELDS_FETCH_ERROR = 'SEARCH/PROPERTY_FIELDS_FETCH_ERROR';

export const PROPERTY_SUBDIVISIONCODES_FETCH_START =
  'SEARCH/PROPERTY_SUBDIVISIONCODES_FETCH_START';
export const PROPERTY_SUBDIVISIONCODES_FETCH_SUCCESS =
  'SEARCH/PROPERTY_SUBDIVISIONCODES_FETCH_SUCCESS';
export const PROPERTY_SUBDIVISIONCODES_FETCH_ERROR =
  'SEARCH/PROPERTY_SUBDIVISIONCODES_FETCH_ERROR';

export const PROPERTY_CHANGE_CURRENT_PAGE =
  'SEARCH/PROPERTY_CHANGE_CURRENT_PAGE';
export const PROPERTY_CHANGE_SORT_MODEL = 'SEARCH/PROPERTY_CHANGE_SORT_MODEL';
export const PROPERTY_CHANGE_PAGE_SIZE = 'SEARCH/PROPERTY_CHANGE_PAGE_SIZE';

export const PROPERTY_CODES_FETCH_START = 'SEARCH/PROPERTY_CODES_FETCH_START';
export const PROPERTY_CODES_FETCH_SUCCESS =
  'SEARCH/PROPERTY_CODES_FETCH_SUCCESS';
export const PROPERTY_CODES_FETCH_ERROR = 'SEARCH/PROPERTY_CODES_FETCH_ERROR';

export const fetchSearchOptions = makeApiActionCreatorV3(
  api.fetchSearchOptions,
  SEARCH_OPTIONS_FETCH_START,
  SEARCH_OPTIONS_FETCH_SUCCESS,
  SEARCH_OPTIONS_FETCH_ERROR,
);
export const searchProperty = makeApiActionCreatorV3(
  api.searchProperty,
  PROPERTY_SEARCH_START,
  PROPERTY_SEARCH_SUCCESS,
  PROPERTY_SEARCH_ERROR,
);
export const fetchFields = makeApiActionCreatorV3(
  api.fetchFields,
  PROPERTY_FIELDS_FETCH_START,
  PROPERTY_FIELDS_FETCH_SUCCESS,
  PROPERTY_FIELDS_FETCH_ERROR,
);
export const fetchSubdivisionCodes = makeApiActionCreatorV3(
  api.fetchSubdivisionCodes,
  PROPERTY_SUBDIVISIONCODES_FETCH_START,
  PROPERTY_SUBDIVISIONCODES_FETCH_SUCCESS,
  PROPERTY_SUBDIVISIONCODES_FETCH_ERROR,
);
export const fetchCodes = makeApiActionCreatorV3(
  api.fetchCodes,
  PROPERTY_CODES_FETCH_START,
  PROPERTY_CODES_FETCH_SUCCESS,
  PROPERTY_CODES_FETCH_ERROR,
);

export function changeCurrentPage(page) {
  return async dispatch => {
    dispatch({ type: PROPERTY_CHANGE_CURRENT_PAGE, data: page });
  };
}

export function changeSortModel(model) {
  return async dispatch => {
    dispatch({ type: PROPERTY_CHANGE_SORT_MODEL, data: model });
  };
}

export function changePageSize(page) {
  return async dispatch => {
    dispatch({ type: PROPERTY_CHANGE_PAGE_SIZE, data: page });
  };
}
